import DGHead from "./dg-head.vue";
import DGCopyright from "./dg-copyright.vue";
import DGPaswIntensity from "./dg-pasw-intensity.vue";
import DGState from "./dg-state.vue";
import DGTitle from "./dg-title.vue";
import DGUpload2 from "./dg-upload2.vue";
import DGDialog from "./dg-dialog.vue";
import DGList from "./dg-list.vue";
import DGListItem from "./dg-list-item.vue";
import DGFormDialog from "./dg-form-dialog.vue";
import DGUpload from "./dg-upload.vue";
import DGPage from "./dg-page.vue";

import DGStep from "./dg-step.vue";
import DGAlertBox from "./dg-alert-box.vue";
import DgCascader from "./dg-cascader.vue";
import DGPdfpreview from "./dg-pdfpreview.vue";
import DGLink from "./dg-link.vue";
import DGStatusTip from "./dg-status-tip.vue";
import DGContact from "./dg-contact.vue";
import DGSignEntry from "./dg-sign-entry.vue";

const components = [DgCascader, DGSignEntry, DGStatusTip, DGContact, DGLink, DGPdfpreview, DGCopyright, DGList, DGUpload2, DGFormDialog, DGListItem, DGTitle, DGUpload, DGDialog, DGHead, DGPaswIntensity, DGState, DGPage, DGStep, DGAlertBox];

const install = function (Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  DGPdfpreview,
  DGContact,
  DGCopyright,
  DGStep,
  DGUpload2,
  DGLink,
  DGAlertBox,
  DGFormDialog,
  DGList,
  DGListItem,
  DGSignEntry,
  DGDialog,
  DGUpload,
  DGTitle,
  DGPaswIntensity,
  DGState,
  DGHead,
  DGPage,
  DgCascader,
  DGStatusTip,
};
